import { Box, Divider, Stack, Toolbar } from '@mui/material'
import { Link } from 'react-router-dom'

import { useAuth } from '../../Shared/Contexts/AuthContext.jsx'
import Search from '../../Shared/Search/Search.jsx'
import Can from '../Can/Can.jsx'
import Show from '../Can/Show.jsx'
import ChangeOrganizationToggle from '../ChangeOrganizationToggle/ChangeOrganizationToggle'
import LanguageToggle from '../LanguageToggle/LanguageToggle.jsx'
import Logo from '../Logo/Logo.jsx'
import NotificationsToggle from '../NotificationsToggle/NotificationsToggle.jsx'
import ProfileBadge from '../ProfileBadge/ProfileBadge.jsx'
import ThemeToggle from '../ThemeToggle/ThemeToggle.jsx'
import TimePicker from '../TimePicker/TimePicker.jsx'

const NavBar = () => {
  const {
    currentUser: { isSuperAdmin }, authState: { isAuthenticated }
  } = useAuth()

  return (
    <>
      <Toolbar>
        <Link to="/">
          <Box sx={{
            width: '140px',
            margin: 'auto'
          }}>
            <Logo />
          </Box>
        </Link>

        <Box sx={{ flexGrow: 1 }} />

        <Search />

        <Box sx={{ flexGrow: 1 }} />

        <Stack
          direction="row"
          edge="end"
          sx={{ padding: '5px 16px' }}
        >
          <Can action="notifications_r">
            <NotificationsToggle />
          </Can>
          <ThemeToggle />
          <LanguageToggle />

          <Show when={() => !isSuperAdmin && isAuthenticated}>
            <ChangeOrganizationToggle />
          </Show>
        </Stack>
        <Divider
          orientation="vertical"
          flexItem
        />
        <TimePicker />
        <Divider
          orientation="vertical"
          flexItem
        />
        <ProfileBadge />
      </Toolbar>
    </>
  )
}

export default NavBar
